function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1032",
  "data-name": "Path 1032",
  d: "M48.965,48.229a1.753,1.753,0,0,0-2.539,0l-.968.968c-.06.061-1.512,1.27-4.6-1.814s-1.875-4.535-1.814-4.6l.968-.968a1.753,1.753,0,0,0,0-2.54l-1.935-1.935a1.753,1.753,0,0,0-2.54,0l-.968.968c-.181.181-3.991,4.172,3.628,11.731,3.749,3.749,6.652,4.717,8.587,4.717a4.638,4.638,0,0,0,3.144-1.088L50.9,52.7a1.749,1.749,0,0,0,0-2.539Z",
  transform: "translate(-32.462 -33.811)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1033",
  "data-name": "Path 1033",
  d: "M60.3,41.411a.629.629,0,0,1-.89.89L57,39.886,54.581,42.3a.629.629,0,0,1-.89-.89L56.106,39l-2.415-2.415a.629.629,0,0,1,.89-.89L57,38.106l2.415-2.415a.629.629,0,0,1,.89.89L57.886,39Z",
  transform: "translate(-39.013 -35)",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 1
});

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.04,
    height: 21.949,
    viewBox: "0 0 22.04 21.949",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.6b5cf920.svg";
export { ForwardRef as ReactComponent };